// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__MUn-o","label":"Section_label__11tAK","contentWrap":"Section_contentWrap__3P-Tc","footer":"Section_footer__2Trlc","footerInner":"Section_footerInner__vlXmK"};